import React, { useEffect, useState } from 'react';
import { Modal, Spinner, ModalBody, ModalHeader } from 'reactstrap';

const ModalErroProdFinalOneDrive = ( props ) => {

    const toggleModalErro = () => {props.setOpenModalErro(!props.openModalErro)}

    return (
        <Modal isOpen={props.openModalErro} toggle={toggleModalErro} centered>
            <ModalHeader>
                <span className='text-danger'>Erro ao capturar o Produto Final no OneDrive</span>
            </ModalHeader>
            <ModalBody>
                <h5>O checklist abaixo pode te ajudar:</h5>
                <p>- Verifique se a pasta do produto realmente existe no OneDrive.</p>
                <p>- Verifique se a pasta do produto no OneDrive está vazia.</p>
            </ModalBody>
        </Modal>
    )
}

export default ModalErroProdFinalOneDrive;
